import { render, staticRenderFns } from "./TrxWithdraw.vue?vue&type=template&id=d2d92292"
import script from "./TrxWithdraw.vue?vue&type=script&lang=js"
export * from "./TrxWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports